import ROUTE_NAMES from "@/app/exercise/router/router-const";
export default [
  {
    path: "training-chapter-categories",
    name: ROUTE_NAMES.TRAINING_CHAPTER_CATEGORIES,
    component: () =>
      import("@/app/exercise/modules/training-chapter-categories/ChapterCategoryPage.vue")
  }
];
